import { APIMethod, fetchData } from "@client";

export async function removeTemplateQuery(id) {
  await fetchData(`/template/${id}`, APIMethod.DELETE);
}
